import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";
import { toPairs } from "lodash-es";
import { useEffect } from "react";
import { $createButtonListNode, ButtonListNodeMui } from "../nodes/button-list-mui";
import { $isButtonListNode } from "../nodes/button-list-node";
import { INSERT_BUTTON_LIST_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

import type { InsertButtonListCommand } from "../types/commands";

export function ButtonListPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_BUTTON_LIST_COMMAND,
        (data: InsertButtonListCommand) => {
          // Without a caret Lexical's $insertNodes falls back to the end of the document.
          $insertNode($createButtonListNode(editor._headless, data.buttons));

          return true;
        },
        1,
      ),
    [editor],
  );

  useEffect(
    () =>
      editor.registerMutationListener(ButtonListNodeMui, (mutatedNodes) => {
        toPairs(mutatedNodes).forEach(([key, mutation]) => {
          if (mutation !== "destroyed") {
            editor.update(() => {
              const node = $getNodeByKey(key);
              if (!node) return;
              if (!$isButtonListNode(node)) return;

              if (node.__buttons.length === 0) {
                node.remove();
              }
            });
          }
        });
      }),
    [editor],
  );

  return null;
}
